export const c_menu__content_Height = {
  "name": "--pf-v6-c-menu__content--Height",
  "value": "auto",
  "var": "var(--pf-v6-c-menu__content--Height)"
};
export default c_menu__content_Height;